import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
import BlogList from '@modules/blog/components/BlogList';
import { Alert, Stack, Typography } from '@mui/material';

const ViewerContent = () => {
    return (
        <Layout
            heading="Viewer Content"
            breadcrumbs={[
                { label: 'Dashboard', href: '/', value: 'dashboard' },
                { label: 'Viewer Content', href: '/viewer', value: 'viewer' },
            ]}
        >
            <Stack spacing={2} sx={{ p: 3 }}>
                <Alert severity="info">Read-only view. Editing controls are disabled.</Alert>
                <PermissionGate permission="content:read">
                    <Typography variant="h6">Published Blog Posts</Typography>
                    <BlogList />
                </PermissionGate>
            </Stack>
        </Layout>
    );
};

export default ViewerContent;
